import React from 'react';

import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// react-query-devtools is the legacy v2 version. Remove when removing "react-query"!
import { ReactQueryDevtools as LegacyReactQueryDevtools } from 'react-query-devtools';
import {
  // ReactQueryConfigProvider is the legacy v2 version. Remove when removing "react-query"!
  ReactQueryConfigProvider as LegacyReactQueryConfigProvider,
} from 'react-query';

const legacyReactQueryConfig = {
  queries: {
    retry: 1,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  },
};

const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
});

export default function ReactQueryProviders({ children }) {
  return (
    <LegacyReactQueryConfigProvider config={legacyReactQueryConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
        {localStorage.getItem('reactQueryDevtools') && (
          <>
            <LegacyReactQueryDevtools initialIsOpen={false} />
            <ReactQueryDevtools initialIsOpen={false} />
          </>
        )}
      </QueryClientProvider>
    </LegacyReactQueryConfigProvider>
  );
}
ReactQueryProviders.displayName = 'ReactQueryProviders';
